export default (number: any) => {
  if (number == null) return null

  return typeof number === "number"
    ? Number(number.toFixed(3))
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
    : Number(number)
}
